import { Box, styled } from '@mui/material';
import { MedicalDeviceLabelContainer } from 'components/layout/LandingPage/landingPage.styles';
import DynamicMedicalDeviceLabel from 'components/regulatory/DynamicMedicalDeviceLabel';
import { useSession, useSessionExpiryModal } from 'providers';
import { SESSION_STATE } from 'providers/SessionProvider/sessionProvider.constants';
import { AUTH_MODAL_Z_INDEX } from 'style/constants';
import { AuthManagerProvider } from '../AuthManager/Context/AuthManagerProvider';
import { CloudflareLogin } from '../CloudflareLogin/CloudflareLogin';
import { ExpiredSessionManager } from './ExpiredSessionManager';

const BlurBackdrop = styled(Box)({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backdropFilter: 'blur(4px)',
  width: '100dvw',
  height: '100dvh',
  zIndex: AUTH_MODAL_Z_INDEX - 1,
});

export const ExpiredSessionLogin = () => {
  const { sessionState } = useSession();
  const { isModalOpen, closeSessionExpiryModal } = useSessionExpiryModal();

  return (
    <AuthManagerProvider>
      <CloudflareLogin
        triggerLogin={
          sessionState === SESSION_STATE.EXPIRED ||
          sessionState === SESSION_STATE.UNAUTHENTICATED
        }
        successCallback={closeSessionExpiryModal}
      />
      <ExpiredSessionManager />
      {isModalOpen && <BlurBackdrop />}
      {isModalOpen && (
        <MedicalDeviceLabelContainer sx={{ zIndex: AUTH_MODAL_Z_INDEX }}>
          <DynamicMedicalDeviceLabel />
        </MedicalDeviceLabelContainer>
      )}
    </AuthManagerProvider>
  );
};
